var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#65c7e1",
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z",
    opacity: 1,
    fill: "#e7c192"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#e7c192",
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332e29",
    d: "M508.006+88.039L520.206+88.039C624.299+88.039+708.683+173.662+708.683+279.283L708.683+279.283C708.683+331.645+472.412+116.075+515.746+115.512C563.824+114.888+319.529+332.543+319.529+279.283L319.529+279.283C319.529+173.662+403.913+88.039+508.006+88.039Z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#332e29",
    d: "M311.974+274.732L312.732+274.732C329.677+274.732+343.415+288.282+343.415+304.998L343.415+304.998C343.415+321.713+329.677+335.264+312.732+335.264L311.974+335.264C295.028+335.264+281.291+321.713+281.291+304.998L281.291+304.998C281.291+288.282+295.028+274.732+311.974+274.732Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#332e29",
    d: "M722.332+275.356L721.574+275.356C704.628+275.356+690.891+288.907+690.891+305.622L690.891+305.622C690.891+322.337+704.628+335.888+721.574+335.888L722.332+335.888C739.277+335.888+753.015+322.337+753.015+305.622L753.015+305.622C753.015+288.907+739.277+275.356+722.332+275.356Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M304.481+327.18L305.239+327.18C322.185+327.18+335.922+340.731+335.922+357.446L335.922+357.446C335.922+374.162+322.185+387.712+305.239+387.712L304.481+387.712C287.536+387.712+273.798+374.162+273.798+357.446L273.798+357.446C273.798+340.731+287.536+327.18+304.481+327.18Z",
    fill: "#332e29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#332e29",
    opacity: 1,
    d: "M729.824+327.805L729.067+327.805C712.121+327.805+698.384+341.355+698.384+358.071L698.384+358.071C698.384+374.786+712.121+388.337+729.067+388.337L729.824+388.337C746.77+388.337+760.507+374.786+760.507+358.071L760.507+358.071C760.507+341.355+746.77+327.805+729.824+327.805Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.615+380.254L304.273+380.254C318.993+380.254+330.927+392.526+330.927+407.664L330.927+407.664C330.927+422.803+318.993+435.075+304.273+435.075L303.615+435.075C288.894+435.075+276.961+422.803+276.961+407.664L276.961+407.664C276.961+392.526+288.894+380.254+303.615+380.254Z",
    fill: "#332e29",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#332e29",
    d: "M730.691+380.878L730.033+380.878C715.312+380.878+703.379+393.15+703.379+408.289L703.379+408.289C703.379+423.427+715.312+435.699+730.033+435.699L730.691+435.699C745.411+435.699+757.345+423.427+757.345+408.289L757.345+408.289C757.345+393.15+745.411+380.878+730.691+380.878Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M310.852+430.205L311.35+430.205C322.507+430.205+331.551+439.318+331.551+450.559L331.551+450.559C331.551+461.801+322.507+470.914+311.35+470.914L310.852+470.914C299.695+470.914+290.651+461.801+290.651+450.559L290.651+450.559C290.651+439.318+299.695+430.205+310.852+430.205Z",
    fill: "#332e29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.454+430.829L722.955+430.829C711.799+430.829+702.754+439.942+702.754+451.184L702.754+451.184C702.754+462.425+711.799+471.538+722.955+471.538L723.454+471.538C734.611+471.538+743.655+462.425+743.655+451.184L743.655+451.184C743.655+439.942+734.611+430.829+723.454+430.829Z",
    opacity: 1,
    fill: "#332e29"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent20);
export default __webpack_public_path__ + "static/media/Student 20.368e46b53398e8146944a655807427e5.svg";
export { ForwardRef as ReactComponent };